import { apiGet, apiGetPaginated, apiPatch, apiPost, PaginatedResult } from '../client'

export type CareerExpertBookingStatus = 'PENDING_PAYMENT' | 'CONFIRMED' | 'COMPLETED' | 'CANCELLED'

export interface CareerExpertBooking {
  amount: number
  createdAt: string
  currency: string
  id: string
  notes: string | null
  planAtBooking: 'FREE' | 'BASIC' | 'PRO'
  status: CareerExpertBookingStatus
  stripeCheckoutSessionId: string | null
  studentId: string
}

export interface BookCareerExpertSessionPayload {
  cancelUrl: string
  successUrl: string
}

/** Pro students get `data` back as the confirmed CareerExpertBooking itself
 * (no `url`); Free/Basic students get a checkout session to redirect to. */
export type BookCareerExpertSessionResult =
  | CareerExpertBooking
  | { bookingId: string; sessionId: string; url: string }

export const bookCareerExpertSession = (payload: BookCareerExpertSessionPayload) =>
  apiPost<BookCareerExpertSessionResult>('/career-expert/book', payload)

export const listMyCareerExpertBookings = () => apiGet<CareerExpertBooking[]>('/career-expert/bookings')

// ─── Super admin ────────────────────────────────────────────────────────────

export interface AdminCareerExpertBooking extends CareerExpertBooking {
  student: { avatarUrl: string | null; firstName: string; lastName: string; userId: string }
}

export interface AdminCareerExpertBookingDetail extends CareerExpertBooking {
  stripePaymentIntentId: string | null,
  student: { avatarUrl: string | null; firstName: string; lastName: string; user: { email: string | null; phone: string | null }; userId: string },
  updatedAt: string
}

export interface UpdateCareerExpertBookingStatusPayload {
  notes?: string
  status: CareerExpertBookingStatus
}

export const listAllCareerExpertBookings = (params?: { limit?: number; page?: number; planAtBooking?: 'FREE' | 'BASIC' | 'PRO' }): Promise<PaginatedResult<AdminCareerExpertBooking[]>> =>
  apiGetPaginated<AdminCareerExpertBooking[]>('/career-expert/bookings/all', { params })

export const getAdminCareerExpertBooking = (id: string) => apiGet<AdminCareerExpertBookingDetail>(`/career-expert/bookings/${id}`)

export const updateCareerExpertBookingStatus = (id: string, payload: UpdateCareerExpertBookingStatusPayload) =>
  apiPatch<AdminCareerExpertBookingDetail>(`/career-expert/bookings/${id}`, payload)
